// Mock data for Move Van Ltd

export const COMPANY = {
  name: 'Move Van Ltd',
  tagline: 'Moving Made Simple',
  phone: '07985 291097',
  phoneAlt: '07985 291097',
  email: 'bookings@movevanltd.com',
  tidePayUrl: 'https://pay.tide.co/pay/6d065db5-baf2-4969-8d33-1ad5ca43f6a3',
  address: '66 Paul Street, London, England, United Kingdom, EC2A 4NA',
  hours: '24/7 Service \u2014 Available Anytime, Day or Night',
};

export const SERVICES = [
  {
    id: 'house-removals',
    icon: 'Home',
    title: 'House & Flat Removals',
    short: 'Full home moves across London and the surrounding counties.',
    description:
      'From studio flats to five-bedroom family homes, our team handles every step of your house move with care, speed and professionalism.',
    image:
      'https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'office-removals',
    icon: 'Building2',
    title: 'Office & Commercial Moves',
    short: 'Minimise downtime, maximise efficiency.',
    description:
      'We relocate offices, shops and commercial premises with minimal disruption to your business. Evening and weekend moves available.',
    image:
      'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'man-and-van',
    icon: 'Truck',
    title: 'Man & Van Services',
    short: 'Flexible, affordable, from £45/hr.',
    description:
      'A friendly driver, a reliable van and all the help you need. Perfect for single items, small moves and student moves.',
    image:
      'https://images.unsplash.com/photo-1591706515036-cb0f48dc5e62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'furniture-delivery',
    icon: 'Sofa',
    title: 'Furniture & Large Item Delivery',
    short: 'eBay, IKEA, Facebook Marketplace & more.',
    description:
      'Need a sofa, wardrobe or appliance delivered? We collect from any store or private seller and deliver safely to your door.',
    image:
      'https://images.unsplash.com/photo-1602770318920-7a02839e5c4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'same-day',
    icon: 'Zap',
    title: 'Same-Day Collections & Deliveries',
    short: 'Need it moved today? We’re on it.',
    description:
      'Last-minute booking? Ask us — same-day collections and deliveries are often possible across London and nearby towns, subject to availability.',
    image:
      'https://images.unsplash.com/photo-1620455800201-7f00aeef12ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'rubbish-clearance',
    icon: 'Trash2',
    title: 'Rubbish & Waste Clearance',
    short: 'Registered waste carrier (CBDU666099).',
    description:
      'Responsible rubbish removal for homes, landlords, offices and construction projects. We recycle wherever possible.',
    image:
      'https://images.pexels.com/photos/7464481/pexels-photo-7464481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'house-clearances',
    icon: 'Boxes',
    title: 'House, Garage & Garden Clearances',
    short: 'Full property clearances, done fast.',
    description:
      'Clearing an estate, a garage or an overgrown garden? We handle furniture, appliances, garden waste and everything in between.',
    image:
      'https://images.pexels.com/photos/7464682/pexels-photo-7464682.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'end-of-tenancy',
    icon: 'Key',
    title: 'Landlord & End-of-Tenancy Clearances',
    short: 'Empty, tidy properties ready for the next tenant.',
    description:
      'A trusted partner for landlords, letting agents and tenants. We clear properties quickly so you can get back to business.',
    image:
      'https://images.unsplash.com/photo-1663625318264-695d2d04f11a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'nationwide',
    icon: 'MapPin',
    title: 'Longer-Distance Moves',
    short: 'Out-of-town moves from London and the Home Counties.',
    description:
      'Moving out of London to Reading, Oxford, Cambridge, Brighton or another town nearby? We quote longer moves at a fixed price agreed before the day.',
    image:
      'https://images.unsplash.com/photo-1641199788912-9a7385a35c82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
  {
    id: 'seven-five-tonne',
    icon: 'Truck',
    title: '7.5 Tonne Lorry Removals',
    short: 'Big moves in one trip — from £120/hr.',
    description:
      'Our 7.5-tonne lorry with a 3-man crew can move a large home in fewer trips than a van. Includes a tail-lift, blankets and straps.',
    image:
      'https://images.unsplash.com/photo-1601584115197-04ecc0da31d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  },
];

export const VAN_PRICING = [
  {
    size: '1 Man & Van',
    price: '£45',
    unit: 'per hour',
    capacity: 'Up to 800kg',
    best: 'Single items, small moves & deliveries',
    features: ['Driver only — no helper', 'Blankets & straps included', 'Good for single items & small moves'],
  },
  {
    size: '2 Man & Van',
    price: '£60',
    unit: 'per hour',
    capacity: 'Up to 1200kg',
    best: '1 & 2-bed flats & house moves',
    featured: true,
    features: ['1 driver + 1 helper', 'Blankets & straps included', 'Faster loading & unloading'],
  },
  {
    size: 'Large Luton Van',
    price: '£80',
    unit: 'per hour',
    capacity: 'Up to 1500kg',
    best: '3+ bed homes & offices',
    features: ['2-man crew included', 'Tail-lift available', 'Fits a 3-bed home'],
  },
  {
    size: 'Longer moves / Fixed',
    price: 'POA',
    unit: 'custom quote',
    capacity: 'Any size load',
    best: 'Long-distance & large clearances',
    features: ['Fixed-price quote', 'Agreed before the day', 'No hidden fees'],
  },
  {
    size: '7.5 Tonne Lorry',
    price: '£120',
    unit: 'per hour',
    capacity: 'Up to 3,000kg · ~40 m³',
    best: 'Large homes & offices',
    features: ['3-man crew included', 'Tail-lift & trolleys', '4-hour minimum'],
  },
];

export const FEATURES = [
  { icon: 'ShieldCheck', title: 'Fully Insured', text: 'Goods-in-transit & public liability cover up to £10,000.' },
  { icon: 'Clock', title: 'Punctual & Reliable', text: 'On-time arrivals, every time. Live ETAs sent by text.' },
  { icon: 'PoundSterling', title: 'Transparent Pricing', text: 'Fixed hourly rates. No hidden fees, no surprises.' },
  { icon: 'Users', title: 'Experienced Team', text: 'Trained movers with 10+ years of hands-on experience.' },
  { icon: 'Leaf', title: 'Registered Waste Carrier', text: 'Environment Agency registration CBDU666099 — check it on the public register.' },
  { icon: 'Phone', title: '24/7 Support', text: 'Call, text or WhatsApp us 24 hours a day, 7 days a week.' },
];

export const STEPS = [
  { n: '01', title: 'Request a Quote', text: 'Call us or fill in the online form — takes under 60 seconds.' },
  { n: '02', title: 'Confirm Your Booking', text: 'We lock in the date, time and van size that suits you.' },
  { n: '03', title: 'We Collect & Load', text: 'Our team arrives at the booked time, protects your items and loads up.' },
  { n: '04', title: 'Safe Delivery', text: 'We transport, unload and place everything exactly where you want it.' },
];

export const TESTIMONIALS = [
  {
    name: 'Sarah Mitchell',
    role: 'Homeowner, Clapham',
    rating: 5,
    text: 'Absolutely brilliant service from start to finish. The lads were on time, careful with every single item and even reassembled the beds. Worth every penny.',
    avatar: 'https://images.unsplash.com/photo-1521790797524-b2497295b8a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=200',
  },
  {
    name: 'James Patterson',
    role: 'Office Manager, Shoreditch',
    rating: 5,
    text: 'We moved our 20-person office over a weekend and were back up and running by Monday morning. Professional, efficient and reasonably priced.',
    avatar: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200',
  },
  {
    name: 'Priya Shah',
    role: 'Landlord, East London',
    rating: 5,
    text: 'Needed an end-of-tenancy clearance at short notice. They came the same day, cleared everything and left the flat spotless. My go-to from now on.',
    avatar: 'https://images.unsplash.com/photo-1698917414969-feade59e3343?crop=entropy&cs=srgb&fm=jpg&q=85&w=200',
  },
  {
    name: 'Thomas Walker',
    role: 'Student, Kingston',
    rating: 5,
    text: 'Moved all my stuff from halls to a new flat for an unbeatable price. Friendly driver, no fuss. Would recommend to any student in London.',
    avatar: 'https://images.unsplash.com/photo-1521790797524-b2497295b8a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=200',
  },
];

export const AREAS = [
  'London', 'Reading', 'Watford', 'Luton', 'Slough', 'Guildford', 'Woking',
  'St Albans', 'Chelmsford', 'Oxford', 'Cambridge', 'Milton Keynes', 'Brighton',
];

export const FAQS = [
  {
    q: 'How quickly can you book me in?',
    a: 'For most jobs in London we can offer same-day or next-day availability. For larger moves we recommend booking 3–5 days in advance.',
  },
  {
    q: 'Are my belongings insured?',
    a: 'Yes. All moves include goods-in-transit insurance up to £10,000 and public liability cover of £1,000,000 as standard.',
  },
  {
    q: 'Do you charge by the hour or a fixed price?',
    a: 'Local moves are typically charged by the hour (minimum 2 hours). Long-distance moves and clearances are quoted at a fixed price with no surprises.',
  },
  {
    q: 'Will the van and driver arrive together?',
    a: 'It depends on the package. 1 Man & Van is the driver only; 2 Man & Van adds a helper; the Luton and 7.5 tonne lorry come with 2–3 crew. Blankets and straps are included.',
  },
  {
    q: 'Do you dispose of waste responsibly?',
    a: 'Move Van Ltd is a registered waste carrier — you can check registration CBDU666099 on the Environment Agency public register. Ask us where your waste will go when you book.',
  },
  {
    q: 'Which areas do you cover?',
    a: 'We work across Greater London and the towns around it — including Reading, Watford, Luton, Slough, Guildford, Woking, St Albans, Chelmsford, Oxford, Cambridge, Milton Keynes and Brighton. Not sure if we reach you? Put your postcodes into the instant quote and it will tell you.',
  },
];

export const HERO_IMAGE =
  'https://customer-assets-agu9un31.emergentagent.net/job_move-van-ltd/artifacts/fktgw7ez_Move%20van%20canary%20wharf.png';

export const ABOUT_IMAGE =
  'https://customer-assets-agu9un31.emergentagent.net/job_move-van-ltd/artifacts/fktgw7ez_Move%20van%20canary%20wharf.png';

export const BRAND_LOGO =
  'https://customer-assets-agu9un31.emergentagent.net/job_move-van-ltd/artifacts/mt9igrhz_Move%20van%20logo%20no%20pictures.webp';

export const BOOKING_URL =
  'https://app.squareup.com/appointments/book/f356z0oipm1egp/LH2MJT8CA787D/start';

export const LICENSES = [
  {
    id: 'waste-carrier',
    icon: 'Recycle',
    title: 'Environment Agency Waste Carrier',
    reg: 'CBDU666099',
    issuer: 'Environment Agency',
    role: 'Upper Tier Waste Carrier, Broker & Dealer',
    issued: '6 October 2026',
    expires: '6 October 2029',
    status: 'Up to date',
    description:
      'Registered on the Environment Agency public register as an upper-tier carrier, broker and dealer (MOVEVAN LTD, CBDU666099, expires 6 October 2029). Registration is a legal requirement, not an endorsement.',
    docUrl: 'https://environment.data.gov.uk/public-register/waste-carriers-brokers/registration/CBDU666099', docOk: true,
  },
  {
    id: 'goods-in-transit',
    icon: 'ShieldCheck',
    title: 'Goods in Transit Insurance',
    reg: '£10,000 cover',
    issuer: 'Commercial Insurance',
    role: 'Protection for your belongings in our vans',
    issued: 'Current policy',
    expires: 'Renewed annually',
    status: 'Details on request',
    description:
      'Goods in transit cover with a limit of £10,000, subject to the policy terms and exclusions. Ask us if you have high-value items.',
  },
  {
    id: 'public-liability',
    icon: 'Umbrella',
    title: 'Public Liability Insurance',
    reg: '£1,000,000 cover',
    issuer: 'Commercial Insurance',
    role: 'Protection for people & property on-site',
    issued: 'Current policy',
    expires: 'Renewed annually',
    status: 'Details on request',
    description:
      '£1 million of public liability cover protects you, your property and anyone else on-site against any accidental damage or injury.',
  },
  {
    id: 'company',
    icon: 'Building2',
    title: 'UK Registered Business',
    reg: 'Move Van Ltd',
    issuer: 'Companies House',
    role: '66 Paul Street, London EC2A 4NA',
    issued: 'Established',
    expires: 'Ongoing (no expiry)',
    status: 'Active',
    description:
      'A UK limited company registered at Companies House.',
  },
];
